import React, { Component } from "react";
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import Draggable from "react-draggable";

import { FetchData } from "./utils/DataFetch";
import { GetCookie } from "./utils/Common";
import { InterpreterFormSearchTableDefault } from "./InterpreterFormSearchTableDefault";
import { InterpreterForm } from "./InterpreterForm";
import AddIcon from "../images/add.png";

export class InterpreterFormSearch extends Component {
  static displayName = InterpreterFormSearch.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    this.state = {
      interpreterList: [],
      alert: props.alert,

      modalInterpreterForm: false,
      model: {
        EventType: "insert",
        IntId: null,
        IntLastName: "",
        IntFirstName: "",
        IntGender: "",
        IntPronoun: "",
        IntEmail: "",
        IntCellTxt: "",
        IntPhoneOnly: "",
        IntFax: "",
        IntBeeper: "",
        IntStreet: "",
        IntCity: "",
        IntState: "",
        IntZip: "",
        IntCountry: "",
        IntSSINumber: "",
        IntActiveFlg: true,
        IntCorporationFlg: false,
        DBA: "",
        InHouseFlg: false,
        UnVettedFlg: false,
        EmergencyContact: "",
        UnavailableReason: "",
        BankName: "",
        BankAccount: "",
        BankRoute: "",
        Rate: null,
        HourMinimum: null,
        Prorate: "",
        ConfCallRate: null,
        BusinessCardRequestDate: null,
        BusinessCardRequestToProcessFlg: false,
        IntNote: "",
        ReferredBy: "",
        DefaultLanguage: "",
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        CreatedBy: "",
        UpdatedBy: "",
      },
      searchModel: {
        Name: props.Name === null ? "" : props.Name,
      },
      deltaPosition: { x: 0, y: 0 },
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setModalInterpreterForm = this.setModalInterpreterForm.bind(this);
    this.handleInterpreterSaveEventSuccess =
      this.handleInterpreterSaveEventSuccess.bind(this);

    if (props.Name !== null && props.Name !== "")
      this.populateInterpreterData();
        
    this.intSearchRef = React.createRef();
  }
   componentDidMount() {
    this.setState({ isMounted: true }); // Set isMounted to true when the component mounts

    document.addEventListener('keydown', this.keydownHandler);

    // Set focus to the rep name field
    setTimeout(() => {
      if (this.intSearchRef.current) {
        this.intSearchRef.current.focus();
      }
    }, 100);

    return () => {
      document.removeEventListener('keydown', this.keydownHandler);
    };
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  setModalInterpreterForm() {
    this.setState({ modalInterpreterForm: !this.state.modalInterpreterForm });
  }

  handleInterpreterSaveEventSuccess(alert) {
    this.setState(
      {
        modalInterpreterForm: alert.modal,
        searchModel: {
          Name: alert.model.IntLastName,
        },
      },
      () => {
        this.populateInterpreterDataOnSave();
      }
    );
  }

  handleChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      const searchModel = { ...this.state.searchModel, Name: e.target.value };
      this.setState({ searchModel }, () => {
        this.populateInterpreterData();
      });
    }
  }

  async populateInterpreterData() {
    this.props.setFetchingData(true);
    await FetchData(
      "/getinterpreters",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({ interpreterList: data });
      this.props.setFetchingData(false);
    });
  }

  async populateInterpreterDataOnSave() {
    await FetchData(
      "/getinterpreters",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      if (data.length > 0) {
        var topData = [];
        topData.push(data[0]);
        this.setState({ interpreterList: topData, loading: false });
      } else this.setState({ interpreterList: data, loading: false });
    });
  }

  renderInterpreterTable(interpreterList) {
    return (
      <InterpreterFormSearchTableDefault
        interpreterList={interpreterList}
        handleDoubleClick={this.props.handleDoubleClick}
      ></InterpreterFormSearchTableDefault>
    );
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition = { x: 0, y: 0 } } = this.state || {};

    return (
      <Draggable
        handle=".interpreter-form-search-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div style={{ width: "400px" }}>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: "800px",
              maxHeight: "500px",
            }}
            backdrop="static"
          >
            <ModalHeader className="interpreter-form-search-handle handle">
              <span style={{ fontSize: "14px" }}>Search Interpreter</span>
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <input
                        name="Name"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.Name}
                        onChange={this.handleChange}
                        ref={this.intSearchRef}
                        placeholder="Interpreter Name (Lastname Firstname)"
                        onKeyDown={this.handleKeyDown}
                      />
                      <Button
                        color="btn"
                        size="sm"
                        onClick={this.setModalInterpreterForm}
                      >
                        <img
                          src={AddIcon}
                          style={{ width: "16px", height: "16px" }}
                          alt="Add"
                        />{" "}
                        New
                      </Button>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col
                    className=" x-panel-body x-layout-fit x-panel-body-default"
                    style={{
                      overflowY: "scroll",
                      height: "450px",
                      backgroundColor: "unset",
                      width: "100%",
                      marginLeft: "8px",
                      marginRight: "10px",
                    }}
                  >
                    {this.renderInterpreterTable(this.state.interpreterList)}
                  </Col>
                </Row>
              </div>
            </ModalBody>
          </Modal>

          {this.state.modalInterpreterForm && (
            <InterpreterForm
              model={this.state.model}
              modal={this.state.modalInterpreterForm}
              alert={this.state.alert}
              setModal={this.setModalInterpreterForm}
              handleSaveEventSuccess={this.handleInterpreterSaveEventSuccess}
            />
          )}
        </div>
      </Draggable>
    );
  }
}
